module.exports = __webpack_public_path__ + "img/status-cancelled.8fd35b7a.svg";